import api from "./api";

/** A translatable field travels as name[en] / name[ar]. */
const translations = (value) => ({ en: value?.en ?? "", ar: value?.ar ?? "" });

/* ---------------------------------------------------------------- categories */
/* Categories and brands stay business-wide: every branch groups its own
   products with the same shared taxonomy. */

/** GET /business/product-categories — the whole tree, these lists are small. */
export const fetchProductCategories = async (params = {}) => {
  const { data } = await api.get("/business/product-categories", { params });
  return data.data.product_categories;
};

export const createProductCategory = async (values) => {
  const { data } = await api.post("/business/product-categories", {
    name: translations(values.name),
    parent_id: values.parentId || null,
    is_active: Boolean(values.isActive),
  });
  return data.data.product_category;
};

export const updateProductCategory = async (id, values) => {
  const { data } = await api.put(`/business/product-categories/${id}`, {
    name: translations(values.name),
    parent_id: values.parentId || null,
    is_active: Boolean(values.isActive),
  });
  return data.data.product_category;
};

export const deleteProductCategory = (id) => api.delete(`/business/product-categories/${id}`);

/* -------------------------------------------------------------------- brands */

export const fetchBrands = async (params = {}) => {
  const { data } = await api.get("/business/brands", { params });
  return data.data.brands;
};

/** Multipart, because a brand can carry a logo. */
const brandForm = (values) => {
  const form = new FormData();
  form.append("name[en]", values.name?.en ?? "");
  form.append("name[ar]", values.name?.ar ?? "");
  form.append("is_active", values.isActive ? "1" : "0");
  if (values.logo) form.append("logo", values.logo);
  return form;
};

export const createBrand = async (values) => {
  const { data } = await api.post("/business/brands", brandForm(values));
  return data.data.brand;
};

export const updateBrand = async (id, values) => {
  const form = brandForm(values);
  // Laravel does not parse multipart on PUT, so tunnel it through POST.
  form.append("_method", "PUT");

  const { data } = await api.post(`/business/brands/${id}`, form);
  return data.data.brand;
};

export const deleteBrand = (id) => api.delete(`/business/brands/${id}`);
